import React from "react";
import Layout from "../../components/Layout/Layout";
import "./RentalManagement.css";
import rental from '../../assets/rental-management.jpeg';

const RentalManagement: React.FC = () => {
    return (
        <Layout>
            <div className="rentalContainer">
                <h1 className="pageTitle">Gestion Locative</h1>
                    <div className="contentPaper">
                        <p className="contentText">
                            Vous êtes propriétaire d'un ou plusieurs logements, d'un immeuble et vous souhaitez faire
                            appel à un professionnel de l'immobilier ?
                        </p>
                        <p className="contentText">
                            <span className="highlightBrand">AKTE IMMOBILIER</span> se charge de trouver des candidats sérieux pour la location de vos
                            biens, que nous gèrerons au quotidien.
                        </p>

                        <p className="sectionTitle"><b>Notre volonté :</b></p>
                        <p className="contentText">
                            Vous enlever la charge de la gestion quotidienne de votre patrimoine et vous
                            <b> garantir des revenus locatifs en toute sérénité</b>.
                        </p>

                        <p className="sectionTitle"><b>Nos engagements</b></p>
                        <ul className="engagementsList">
                            <li>Une estimation du loyer selon le prix du marché</li>
                            <li>Une recherche sérieuse et fiable de vos locataires</li>
                            <li>Des formalités administratives conformes à la législation</li>
                            <li>Une <b>communication fluide et régulière</b> via des compte-rendus de gestion</li>
                            <li>Une gestion des impayés rigoureuse</li>
                        </ul>
                    </div>
                </div>
        </Layout>
    );
};

export default RentalManagement;
